import { render, staticRenderFns } from "./NewIdChartSegment.vue?vue&type=template&id=614d53ef"
import script from "./NewIdChartSegment.vue?vue&type=script&lang=js"
export * from "./NewIdChartSegment.vue?vue&type=script&lang=js"
import style0 from "./NewIdChartSegment.vue?vue&type=style&index=0&id=614d53ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports